import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Grid, Flex, Text, Card, Button, Switch } from '@radix-ui/themes';
import api from '../../api';
import { toast } from 'react-toastify';

const GuardianSettings = () => {
  const guardian = useSelector((state) => state.guardian);
  const [loading, setLoading] = useState(false);
  const [settings, setSettings] = useState({
    emailNotifications: true,
    smsNotifications: false,
    reportFrequency: 'weekly'
  });

  const handleSettingChange = async (setting, value) => {
    try {
      setLoading(true);
      await api.patch(`/guardians/settings/${guardian.details.id}`, {
        [setting]: value
      });

      setSettings(prev => ({
        ...prev,
        [setting]: value
      }));

      toast.success('Settings updated successfully', {
        position: "bottom-right"
      });
    } catch (error) {
      console.error('Error updating settings:', error);
      toast.error('Failed to update settings', {
        position: "bottom-right"
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box width="100%" maxWidth="1080px" p="4">
      <Grid columns="12" gap="4">
        <Box gridColumn="span 12">
          <Flex direction="column" gap="4">
            <Text size="5" weight="bold">Settings</Text>

            <Card>
              <Flex direction="column" gap="4">
                <Flex justify="between" align="center">
                  <Text size="2">Email Notifications</Text>
                  <Switch
                    checked={settings.emailNotifications}
                    onCheckedChange={(checked) => handleSettingChange('emailNotifications', checked)}
                    disabled={loading}
                  />
                </Flex>

                <Flex justify="between" align="center">
                  <Text size="2">SMS Notifications</Text>
                  <Switch
                    checked={settings.smsNotifications}
                    onCheckedChange={(checked) => handleSettingChange('smsNotifications', checked)}
                    disabled={loading}
                  />
                </Flex>

                <Flex direction="column" gap="2">
                  <Text size="2">Report Frequency</Text>
                  <select
                    value={settings.reportFrequency}
                    onChange={(e) => handleSettingChange('reportFrequency', e.target.value)}
                    disabled={loading}
                    className="rounded-md border border-gray-300 p-2"
                  >
                    <option value="daily">Daily</option>
                    <option value="weekly">Weekly</option>
                    <option value="monthly">Monthly</option>
                  </select>
                </Flex>
              </Flex>
            </Card>
          </Flex>
        </Box>
      </Grid>
    </Box>
  );
};

export default GuardianSettings;
